// Helper function for serializing form data
export const serializeFormData = (formData, parameterDefinition) => {
  const result = {};

  parameterDefinition.forEach((param) => {
    if (param.children && param.children.length > 0) {
      // This is a parent parameter, create nested object
      result[param.name] = serializeFormData(formData, param.children);
    } else {
      // This is a leaf parameter, get value from form data
      const fieldPath = param.name;
      if (formData.hasOwnProperty(fieldPath)) {
        result[param.name] = formData[fieldPath];
      }
    }
  });

  return result;
};

// Default email configuration
export const COMPANY_OWNER_EMAIL = {
  value: 'company_owner',
  label: 'Company owner\'s email',
};

// Table columns configuration
export const contactsTableColumns = [
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
  },
  {
    title: 'Role',
    key: 'role',
    dataIndex: 'role',
  },
  {
    title: 'Phone Number',
    key: 'phone',
    dataIndex: 'phone',
  },
  {
    title: 'Email',
    key: 'email',
    dataIndex: 'email',
  },
];
